import { useUserProvider } from '@/context/UserProvider';
import { useEffect, useState } from 'react';
import { UnAddAccountModel } from '@/types/home';
import { fetchMonitorUnaddData } from '@/lib/service';
import { useRouter } from 'next/router';

export default function useMainPremium() {
  const { accountList } = useUserProvider();
  const { isLogin } = useUserProvider();
  const [isLoading, setIsLoading] = useState(true);
  const [unAddAccountList, setUnAddAccountList] = useState<UnAddAccountModel[]>([]);
  const router = useRouter();

  useEffect(() => {
    if (!isLogin) {
      setUnAddAccountList([]);
    } else {
      fetchMonitorUnaddData(router.locale)
        .then((res) => {
          setUnAddAccountList(res?.data ?? []);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [router, isLogin]);

  return {
    isPremium: !!(isLogin && (accountList?.length || unAddAccountList?.length)),
    isLoading,
  };
}
